import { routes } from '@/lib/routes';
import type { DigestItem, QuickAction, Slide } from '@/types';
import type { TranslationKey } from '@/i18n';

export const tickerItems: TranslationKey[] = ['ticker.item1', 'ticker.item2', 'ticker.item3'];

export const pendingItems: TranslationKey[] = ['pending.item1', 'pending.item2', 'pending.item3'];

export const slides: Slide[] = [
  {
    id: 'slide-1',
    kickerKey: 'slide.1.kicker',
    titleKey: 'slide.1.title',
    textKey: 'slide.1.text',
    primaryKey: 'slide.1.primary',
    secondaryKey: 'slide.1.secondary',
    primaryTo: routes.newRequest,
    secondaryTo: routes.portalSection('about'),
    accentA: 'rgba(65, 210, 255, 0.35)',
    accentB: '#123449',
  },
  {
    id: 'slide-2',
    kickerKey: 'slide.2.kicker',
    titleKey: 'slide.2.title',
    textKey: 'slide.2.text',
    primaryKey: 'slide.2.primary',
    secondaryKey: 'slide.2.secondary',
    primaryTo: routes.portalSection('education'),
    secondaryTo: routes.portalSection('news'),
    accentA: 'rgba(217, 167, 58, 0.35)',
    accentB: '#3a2a12',
  },
  {
    id: 'slide-3',
    kickerKey: 'slide.3.kicker',
    titleKey: 'slide.3.title',
    textKey: 'slide.3.text',
    primaryKey: 'slide.3.primary',
    secondaryKey: 'slide.3.secondary',
    primaryTo: routes.app,
    secondaryTo: routes.portalSection('competitions'),
    accentA: 'rgba(158, 128, 255, 0.35)',
    accentB: '#241a3a',
  },
];

/** Owner home stage copy mirrored from NEW-VERSION-1.83 role slides. */
export const ownerFocusSlides = [
  {
    id: 'owner-slide-1',
    kicker: 'Владелец системы',
    title: 'Состояние всей системы',
    text: 'Единая картина заявок, проектов, очереди и критических проверок.',
    accentA: '#41d2ff',
    accentB: '#123d59',
    primaryTo: routes.owner,
  },
  {
    id: 'owner-slide-2',
    kicker: 'Владелец системы',
    title: 'Новые заявки',
    text: 'Проверьте полноту данных и назначьте ответственных.',
    accentA: '#e7b13a',
    accentB: '#3a2a12',
    primaryTo: routes.requests,
  },
  {
    id: 'owner-slide-3',
    kicker: 'Владелец системы',
    title: 'AI-очередь',
    text: 'Два платных слота, честная очередь и контроль бюджета консультанта.',
    accentA: '#9e80ff',
    accentB: '#241a3a',
    primaryTo: routes.assistant,
  },
  {
    id: 'owner-slide-4',
    kicker: 'Владелец системы',
    title: 'Правила и шаблоны',
    text: 'Промпты, шаблоны и чек-листы под версионным контролем.',
    accentA: '#49ddb7',
    accentB: '#0d3a32',
    primaryTo: routes.owner,
  },
] as const;

export const digestItems: DigestItem[] = [
  {
    id: 'digest-1',
    bucket: 'fresh',
    kindKey: 'digest.kind.event',
    titleKey: 'digest.item1',
    agoKey: 'digest.ago.days2',
    colors: ['#2ea8df', '#0c314b'],
  },
  {
    id: 'digest-2',
    bucket: 'important',
    kindKey: 'digest.kind.important',
    titleKey: 'digest.item2',
    agoKey: 'digest.ago.days4',
    colors: ['#ff6e56', '#451d26'],
  },
  {
    id: 'digest-3',
    bucket: 'fresh',
    kindKey: 'digest.kind.news',
    titleKey: 'digest.item3',
    agoKey: 'digest.ago.week',
    colors: ['#49ddb7', '#123e39'],
  },
  {
    id: 'digest-4',
    bucket: 'pending',
    kindKey: 'digest.kind.waiting',
    titleKey: 'digest.item4',
    agoKey: 'digest.ago.today',
    colors: ['#d9a73a', '#3c2c0f'],
  },
];

export const quickActions: QuickAction[] = [
  {
    id: 'request',
    titleKey: 'quickActions.request',
    descriptionKey: 'quickActions.requestText',
    icon: 'briefcase',
    to: routes.newRequest,
  },
  {
    id: 'publications',
    titleKey: 'quickActions.publications',
    descriptionKey: 'quickActions.publicationsText',
    icon: 'document',
    to: routes.journals,
  },
  {
    id: 'calendar',
    titleKey: 'quickActions.calendar',
    descriptionKey: 'quickActions.calendarText',
    icon: 'calendar',
    to: routes.portalSection('news'),
  },
  {
    id: 'assistant',
    titleKey: 'quickActions.assistant',
    descriptionKey: 'quickActions.assistantText',
    icon: 'chat',
    to: routes.assistant,
  },
];
